<template>
  <nav role="navigation" class="navbar">
    <div class="container">
      <div class="navbar-brand">
        <a class="navbar-item" href="/">
          Invoice Generator
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'HeroSectionNavbar'
}
</script>

<style lang="scss" scoped>
.navbar {
  min-height: 3.25rem;
  position: relative;
  z-index: 30;
  .container {
    align-items: stretch;
    display: block;
    min-height: 3.25rem;
    width: 100%;
    .navbar-brand {
      align-items: stretch;
      display: flex;
      flex-shrink: 0;
      min-height: 3.25rem;
      .navbar-item {
        align-items: center;
        display: flex;
        flex-grow: 0;
        flex-shrink: 0;
        padding: .5rem .75rem;
        position: relative;
        img {
          max-height: 1.75rem;
        }
        .desktop-logo {
          display: none;
        }
        .mobile-logo {
          display: block;
        }
      }
    }
  }
}
@media (min-width: 768px) {
  .navbar {
    .container {
      .navbar-brand {
        .navbar-item {
          .desktop-logo {
            display: block;
          }
          .mobile-logo {
            display: none;
          }
        }
      }
    }
  }
}
</style>
